

export const round = (num) => {
    if(isNaN(num) || num === Infinity) return 0

    return Math.round((num + Number.EPSILON) * 100) / 100
}